import { render, staticRenderFns } from "./EmbodyCollege.vue?vue&type=template&id=55148387&scoped=true&lang=html&"
import script from "./EmbodyCollege.vue?vue&type=script&lang=js&"
export * from "./EmbodyCollege.vue?vue&type=script&lang=js&"
import style0 from "./EmbodyCollege.vue?vue&type=style&index=0&id=55148387&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55148387",
  null
  
)

export default component.exports